import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { object } from "prop-types";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import { get } from "@Core/LocalStorage";
import { useDispatch } from 'react-redux';
import actions from "../Redux/Action"
// pages
import Home from "Pages/Home";
import Login from "Pages/Login";
import NoRoute from "@Core/Components/NoRoute";

const Routes = () => {
  const dispatch = useDispatch();
  const srmwuiCustomerObj = get('srmwuiCustomerObj') || {}
  const userTokenData = srmwuiCustomerObj && Object.keys(srmwuiCustomerObj).length ? srmwuiCustomerObj.userToken : '';


  useEffect(() => {
    if ((userTokenData)) {
      dispatch(actions.CommonActions.setUserToken(userTokenData))
      dispatch(actions.CommonActions.setSelectedMenue('home'))
    }
  }, [])

  let isLogin = userTokenData ? true : false;
  // let isLogin = true;

  return (
      <Router basename="/srmwui">
      <Switch>
        <Route exact path={process.env.REACT_APP_LOGIN_ROUTE} component={Login} />
        {/* Add into alphabet order */}
        <PrivateRoute
          isAuthenticated={isLogin}
          exact
          path={process.env.REACT_APP_HOME_ROUTE}
          component={Home}
        />
        <Route component={NoRoute} />
      </Switch>
    </Router>
  );
};

Routes.propTypes = {
  history: object.isRequired,
  location: object.isRequired,
  match: object.isRequired,
};

const RootRoutes = () => <Route component={Routes} />;

export default RootRoutes;
